import { inject, Pipe, PipeTransform } from '@angular/core';
import { FileSignatureController } from '@shared/controllers/file-signature.controller';
import { privateFile } from '@shared/helpers/private-file.helper';
import { publicFile as _publicFile } from '@shared/helpers/public-file.helper';

@Pipe({
  name: 'authFile'
})
export class AuthFilePipe implements PipeTransform {
  private readonly fs = inject(FileSignatureController);

  transform(src: string, width?: number, height?: number, publicFile?: boolean): string | undefined {
    if (!src) return;

    if (publicFile) return _publicFile(src);

    const privateFilePath = privateFile(src);
    const signature = this.fs.getSignature();
    const sharedJwt = this.fs.isSharedJWT;

    if (sharedJwt && !signature) {
      console.log('?shareToken= test path', privateFilePath);
      return `${privateFilePath}?shareToken=${sharedJwt}`;
    }

    return this.appendDimensions(`${privateFilePath}?token=${signature}`, width, height);
  }

  getPrivateFile(src: string, width?: number, height?: number): string | undefined {
    if (!src) return;

    const signature = this.fs.getSignature();
    return this.appendDimensions(`${privateFile(src)}?token=${signature}`, width, height);
  }

  private appendDimensions(path: string, width?: number, height?: number): string {
    if (!width) return path;

    const resolvedHeight = height ?? width;
    return `${path}&width=${width}&height=${resolvedHeight}`;
  }
}
